import { render, staticRenderFns } from "./AddCase.vue?vue&type=template&id=d1aee232&scoped=true&"
import script from "./AddCase.vue?vue&type=script&lang=js&"
export * from "./AddCase.vue?vue&type=script&lang=js&"
import style0 from "./AddCase.vue?vue&type=style&index=0&id=d1aee232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1aee232",
  null
  
)

export default component.exports